import { Traverser } from '../Projects/Pathfinder/Traverser';

export function Pathfinder() {
    return <Traverser />;
}
